"use client";

import BFLSkeleton from "@repo/shared-ui/BFLSkeleton";
import { selectLoginStatus, useAppSelector } from "@repo/web-store";
import { twMerge } from "tailwind-merge";

type ConditionalSubtextProps = {
  subtext?: string;
  className?: string;
};



const ConditionalSubtext = ({ subtext, className }: ConditionalSubtextProps) => {
  const loginStatus = useAppSelector(selectLoginStatus);
  const isLoggedIn = loginStatus === "success" || loginStatus === "perpetual";
  const isLoading = loginStatus === "pending" || subtext === undefined;

  if (isLoading) {
    return <BFLSkeleton width="100%"  classes="rounded-[4px] h-[32px] lg:h-[16px]" />;
  }

  if (isLoggedIn) {
    return null;
  }

  return (
    <p className={twMerge("text-[12px] leading-[16px] font-[400px] text-[#666666]", className)}>
      {subtext ?? ""}
    </p>
  );
};

export default ConditionalSubtext;
